import { useStaticQuery, graphql } from 'gatsby';

const useSite = () => {
  const { strapi } = useStaticQuery(graphql`
    query SiteQuery {
      strapi {
        getSite {
          defaultImage {
            name
            url
            height
            width
            imageFile {
              childImageSharp {
                fixed {
                  src
                  height
                  width
                }
                fluid(maxWidth: 1200, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
                gatsbyImageData(layout: CONSTRAINED, width: 1200, quality: 90, placeholder: BLURRED)
              }
            }
          }
          title
          titleSeparator
          description

          googleMapsApiKey
          recaptchaApiKey

          alert
        }
      }
    }
  `);

  return strapi.getSite;
};

export default useSite;
